import {
	Action,
	ActionScope,
	Pattern
} from "../actionScopes";
import {
	ActionAdapter, 
	SecurityActionEffects 
} from "./actionAdapter";

export class ActionsAdapter implements Iterable<ActionAdapter> {
	private readonly $actions: ActionAdapter[];

	constructor(actions: ActionAdapter[]) {
		this.$actions = actions;
	}

	[Symbol.iterator](): Iterator<ActionAdapter, any, undefined> {
		return this.$actions[Symbol.iterator]();
	}

	hasSubpath = (subpath: string) => {
		return this.$actions.some(a => a.path.startsWith(subpath));
	}

	isAllowed(check: ActionScope | Action) {
		if((check as ActionScope)?.check) {
			//type is either iactionscope base, or more specifically Action
			if(!(check as Action)?.action) {
				return (<Action>check).check(this);
			}
		}

		//unwrap to get to the inner action
		const action = (<Action>check).action;

		let isAllowed = false;
		for(const adapter of this.$actions) {
			if(!adapter.isMatch(action))
				continue;

			if(adapter.effect === SecurityActionEffects.Deny)
				return false;

			isAllowed = adapter.effect === SecurityActionEffects.Allow;
		}

		return isAllowed;
	}

	hasCongruency(pattern: Pattern) {
		let isAllowed = false;

		for(const action of this.$actions) {
			if(!isAllowed && action.effect == SecurityActionEffects.Allow && action.isCongruent(pattern.pattern))
				isAllowed = true;
			else if(action.isMatch(pattern.pattern.path) && action.effect == SecurityActionEffects.Deny)
				return false;
		}

		return isAllowed;
	}

	add(other: ActionsAdapter) {
		return new ActionsAdapter(this.$actions.concat(other.$actions));
	}

	reduce() {
		const denies = this.$actions.filter(a => a.effect == SecurityActionEffects.Deny);

		let effective = this.$actions.filter(a => a.effect == SecurityActionEffects.Allow);

		for(const deny of denies) {
			effective = effective.filter(e => !deny.isMatch(e.path));
		}

		return new ActionsAdapter(effective.concat(denies));
	}
}
